import { useEffect } from 'react';
import { SITE_NAME } from '../app/site-config';

/** Fija el título de la pestaña a algo que identifique la página actual —
 * no solo el nombre del sitio, igual en todas partes. */
export function useDocumentTitle(title: string): void {
  useEffect(() => {
    document.title = title ? `${title} · ${SITE_NAME}` : SITE_NAME;
  }, [title]);
}
